"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingProvider;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _States = require("../../../lib/constants/States");
var _Tracking = require("../../../lib/constants/Tracking");
var _Banners = require("../../Banners");
var _Shimmer = _interopRequireDefault(require("./Shimmer"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const propTypes = {
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  track: _propTypes.func.isRequired
};
function LoadingProvider(_ref) {
  let {
    service,
    track
  } = _ref;
  const [state] = (0, _react2.useService)(service);
  (0, _react.useEffect)(() => {
    if (state.matches(_States.bookingDisabled)) {
      track(_Tracking.userEvents.BOOKING_DISABLED);
    }
    if (state.matches(_States.noResults)) {
      track(_Tracking.userEvents.GENERIC_LOAD_ERROR);
    }
  }, [state, track]);
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "LoadingProvider"
  }, state.matches(_States.pending) && /*#__PURE__*/_react.default.createElement(_Shimmer.default, null), (state.matches(_States.noResults) || state.matches(_States.bookingDisabled)) && /*#__PURE__*/_react.default.createElement(_Banners.ErrorBookingBanner, null));
}
LoadingProvider.propTypes = propTypes;
LoadingProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LoadingProvider",
  "props": {
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};